import { useSnackBar } from "../../../utils/useSnack/useSnackBar";

export const Snack = () => {
    useSnackBar()
    return <></>
}